import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import { Nav, Navbar, Stack, Button, Alert, Modal, Container, Row } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { onError } from "../libs/errorLib";
import axiosInstance from "../axiosApi";
import Logo from '../images/favicon-32x32.png';
import { useTranslation } from 'react-i18next';
import * as dateFns from "date-fns";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import moment from "moment";

function BillCompleteModal(props) {
  const { t } = useTranslation();
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {t('BILL_TITLE')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>{t('BILL_STATUS')}</h4>
        <p>
          {t('BILL_RESULT_OK')}<br/>
          {t('BILL_RESULT_ETC')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function BoardingTicket() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [routes, setRoutes] = useState([]);
  const { id } = useParams();
  const [bookingCar, setBookingCar] = useState(null);
  const { t } = useTranslation();
  const [isBillingKey, setIsBillingKey] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [tempUser, setTempUser] = useState(JSON.parse(localStorage.getItem("access_user")));
  
  useEffect(() => {
    async function onLoad() {
        axiosInstance.get(`/accounts/user/${tempUser.pk}/`).then(function(response) {
          if (typeof response === 'undefined') throw "Raxi App 접속이 종료되었습니다";
          if (response.data.status === 'CARD') {
            setIsBillingKey(true);
          } else {
            setIsBillingKey(false);
          }
        }).catch(function (error) {
          setIsLoading(false);
        });

        axiosInstance.get(`/robotaxi/bookingcar/${id}/`).then(function(response) {
          if (typeof response === 'undefined') throw "Raxi App 접속이 종료되었습니다";
          setBookingCar(response.data);
        }).catch(function (error) {
          setIsLoading(false);
        });
    }
    
    onLoad();
  }, [id]);
  
  async function cancelApproval(book) {
    try {
      const response = await axiosInstance.put(`/robotaxi/bookingcar/${id}/`, book);
      if (typeof response === 'undefined') throw "Raxi App 접속이 종료되었습니다";
      return;
    } catch(error) {
        onError("예약취소에 실패하였습니다.");
    }; 
  }
  
  async function handleDelete(event) {
    event.preventDefault();

    const confirmed = window.confirm(
      "해당 예약건을 취소하시겠습니까?"
    );

    if (!confirmed) {
      return;
    }
    setIsLoading(true);

    try {
      await cancelApproval({
        ing_status: 'G',
      });
      alert("정상적으로 취소되었습니다.")
      setIsLoading(false);
      history.push("/bookingcar");
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  async function handleBookCancel(event) {
    event.preventDefault();

    const confirmed = window.confirm(
      "해당 예약건을 삭제하시겠습니까?"
    );

    if (!confirmed) {
      return;
    }
    setIsLoading(true);

    try {
      const response = await axiosInstance.delete(`/robotaxi/bookingcar/${id}/`);
      if (typeof response === 'undefined') throw "Raxi App 접속이 종료되었습니다";
      alert("정상적으로 삭제되었습니다.")
      setIsLoading(false);
      history.push("/bookingcar");
    } catch(error) {
      onError("예약취소에 실패하였습니다.");
      setIsLoading(false);
    }; 
  }

  async function handleApproval(event) {
    event.preventDefault();
    const confirmed = window.confirm(
      "해당 예약건을 결제하시겠습니까?"
    );

    if (!confirmed) {
      return;
    }

    await handleSubmitCallback();

  }

  async function handleSubmitCallback() {
    let imp_uid = '';
    let pay_amount = 0;
    var merchant_uid = bookingCar.book_date;

    // call paymant process
    if (bookingCar.ticket === 'R') {
      pay_amount = Number(bookingCar.charge) * 2;
    } else {
      pay_amount = Number(bookingCar.charge);
    }

    if (isBillingKey) {
      //등록된 카드로 결재 처리 = payment
      //https://api.iamport.kr/subscribe/payments/again

      axiosInstance.post(`/robotaxi/bookingcarpay_nice_again/`, {
        merchant_uid: merchant_uid,
        amount: pay_amount
      }).then(function(response) {
        showModal();
      }).catch(function (error) {
        console.log(error);
        //not nessary - deletePayError(imp_uid, merchant_uid, rsp);
        setIsLoading(false);
        history.push("/bookingcar");
        onError("예약이 완료되지 않았습니다. 예약내역에서 예약 또는 예약취소 해주세요.(pc1)");
      });
    } else {
      // call paymant process = billingkey + payment
      // https://api.iamport.kr/subscribe/payments/onetime
      //iamport onetime payment by pg:nice
      history.push({
        pathname: '/billingform',
        state: {
          merchant_uid: merchant_uid,
          amount: pay_amount
        }
      });
      setIsLoading(false);
    }
  }
  
  // 오류발생하여 결재처리시 예외처리로 해결함_2022.05.14
  async function deletePayError(imp_uid, merchant_uid, error_msg) {
    try {
      const response = await axiosInstance.post(`/robotaxi/bookingcarpayerror/`, {
        imp_uid: imp_uid,
        merchant_uid: merchant_uid
      });
      alert(error_msg);
      history.push("/bookingcar");
    } catch(error) {
      if (error && error.response && error.response.status) {
        if ( error.response.status === 444 ) {
          onError(error.response.data.message);
        } else {
          onError(t('PROCESS_FAIL'));
        }
      } else {
        onError(t('PROCESS_FAIL'));
      }
      
    };
  }
  
  const downloadQRCode = () => {
    const qrCodeURL = document.getElementById('qrCodeEl')
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    //console.log(qrCodeURL)
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  }
  
  function validateForm() {
    let minutes = 0;

    if (!bookingCar) {
      return false;
    }

    minutes = dateFns.differenceInMinutes(new Date(), new Date(bookingCar.s_date))
    return (
      (Math.abs(minutes) > 10) &&
      (bookingCar.ing_status !== 'G') &&
      dateFns.isAfter(new Date(bookingCar.s_date), new Date())
    );
  }

  function showModal() {
    setModalShow(true);
  }
  
  function hideModal() {
    setModalShow(false);
    history.push("/bookingcar");
  }

  return (
  <Stack gap={3}>
      <div className="bg-light border">
        <h6>예약상세내역</h6>
        <Container>
          <Row>
            노선: {bookingCar && bookingCar.routesection.sectionname}
          </Row>
          <Row>
            {t('DATE_BOOK')}: {bookingCar && moment(new Date(bookingCar.s_date)).format("MM.DD(ddd) HH:mm")}
          </Row>
          <Row>
            {t('GETONSPOT')}: {bookingCar && bookingCar.s_station.stationname}
          </Row>
          <Row>
            {t('GETOFFSPOT')}: {bookingCar && bookingCar.e_station.stationname}
          </Row>
          <Row>
            {t('BOOKER')}: {bookingCar && bookingCar.user.email}
          </Row>
          <Row>
            {t('PERSONS')}: {bookingCar && bookingCar.persons}
          </Row>
        </Container>
      </div>
      <div className="bg-light border">
        { (bookingCar&&bookingCar.ing_status === 'J') ? (
          <>
            <LoaderButton
                block
                variant="danger"
                onClick={handleApproval}
                isLoading={isLoading}
            >
                {t('APPROVAL')}
            </LoaderButton>
            <LoaderButton
                block
                variant="danger"
                onClick={handleBookCancel}
                isLoading={isLoading}
            >
                {t('BOOKCANCEL')}
            </LoaderButton>
          </>
        ) : (
          <>
            <LoaderButton
                block
                variant="danger"
                disabled={!validateForm()}
                onClick={handleDelete}
                isLoading={isLoading}
            >
                {t('BILLCANCEL')}
            </LoaderButton>
          </>
        )}
        예약출발시간 10분 전까지 취소가 가능합니다.
      </div>
      <div className="bg-light border">
        {/*
          <QRCode
            className="center"
            value={`{"url":"/robotaxi/bookingcar/${id}/"}`}
            size={256}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"L"}
            includeMargin={false}
            renderAs={"svg"}
            imageSettings={{
                src: "https://static.zpao.com/favicon.png",
                x: null,
                y: null,
                height: 42,
                width: 42,
                excavate: true,
            }}
        />
        */}

        <QRCode
            id="qrCodeEl"
            value={`{"url":"/robotaxi/bookingcar/${id}/"}`}
            size={256}
            bgColor={"#ffffff"}
            fgColor={"#000000"}
            level={"L"}
            includeMargin={true}
        />

      </div>
      <div>
        <br /><br /><br />
      </div>
  </Stack>
  );
}

export default BoardingTicket;